module.exports = __webpack_public_path__ + "img/menu-commonModule.8f7f2d94.svg";